// This function may be deprecated - as it has been implemented below
export function PNLengthProcessing(self, obj) {
    // Pad this chunk of the partnumber with 3 '0's 
    // ignoring the decimal
    let ar_option_name = obj.option_name.split('.');
    let i = 0;
    for (i = 0; i < ar_option_name.length; i++) {
        if (i == 0) {
            obj.option_name = ar_option_name[i].padStart(3, '0');
        } else {
            obj.option_name += '.' + ar_option_name[i];
        }
    }
    //obj.option_title = self.trim(obj.option_name, '0');
}

// This function may be deprecated - as it has been implemented below
export function CablePriceCalc(self, obj)
{
    // Calculate how much less armor in feet is on the cable
    // multiply this value by 1.5 and subtract this value 
    // from the total cost of the cable
    obj.newdata.forEach(x => {
        if (obj.pc == x.id) {
            if (x.parttemp.includes("Armor Length")) {
                self.getOptionValue(obj.pc, obj.s, "Armor Length", (g, o) => {

                    // There are a couple of parts that reduce the price based on less
                    // length of the armor - I think hydrolic are the only ones that do this
                    // so this is hard coded - This could be ported to a new customer field (I.E. Alt Price)
                    let less_price = isNaN(obj.form_price) ? 0 : +obj.form_price;

                    if (!less_price) {
                        less_price = 1.5;
                        if (obj.option_name == "CB502") { less_price = 4.95; }
                        if (obj.option_name == "CB511") { less_price = 4.7; }
                        if (obj.option_name == "CB512") { less_price = 4.5; }

                        if (obj.option_name == "CB202") { less_price = 1.74; }
                        if (obj.option_name == "CB206") { less_price = 2.05; }
                        if (obj.option_name == "CB212") { less_price = 1.80; }
                        if (obj.option_name == "CB218") { less_price = 2.13; }

                        if (obj.option_name == "CB296") { less_price = 2.05; }
                        if (obj.option_name == "CB298") { less_price = 2.13; }

                        if (obj.option_name == "CB602") { less_price = 2.64; }
                        if (obj.option_name == "CB606") { less_price = 0.90; }
                        if (obj.option_name == "CB611") { less_price = 2.67; }
                        if (obj.option_name == "CB612") { less_price = 1.80; }
                        if (obj.option_name == "CB618") { less_price = 2.88; }

                        if (obj.option_name == "CB802") { less_price = 2.04; }
                        if (obj.option_name == "CB806") { less_price = 0.30; }
                        if (obj.option_name == "CB810") { less_price = 2.04; }
                        if (obj.option_name == "CB811") { less_price = 2.34; }
                        if (obj.option_name == "CB812") { less_price = 1.50; }
                        if (obj.option_name == "CB818") { less_price = 2.88; }
                        if (obj.option_name == "CB819") { less_price = 1.50; }
                    }



                    // Important to multiply by mult since we
                    // have a qty field that can have a multipler
                    let _qty = parseFloat(o.name) * obj.mult;
                    let dif = obj.qty - _qty;
                    let less = dif * less_price;
                    obj.tot_price -= less;

                    // Add to the price info array
                    x.priceinfo.push({
                        property: 'Less Armor',
                        option: 'Discount', qty: dif,
                        price: less_price,
                        tot_price: less,
                        id: '', gid:''
                    });
                });
            }
        }
    });
    if (obj.option_name == 'CB104') { obj.tot_price = 0; }
    if (obj.option_name == 'CB108') { obj.tot_price = 0; }
    if (obj.option_name == 'CB117') { obj.tot_price = 0; }
}

export function invalidAction(def, self, pc, s)
{
    if (def == 'FLIPIT')
    {
    	// in the case of flipit, prevent the bindings
    	// from messing up the flipit functionality
        let cablepc = s.data.find(e => e.name == 'Cable')
        if (cablepc) cablepc.binding = '';

        let _c1 = {}; self.getOptionValueWithSC(pc, s, "C1", (g, o) => { _c1 = o; });
        let _c2 = {}; self.getOptionValueWithSC(pc, s, "C2", (g, o) => { _c2 = o; });

        self.setOptionValX(pc, s, '', '', _c2.name, '', 'C1');
        self.setOptionValX(pc, s, '', '', _c1.name, '', 'C2');
    }

    // The action to add a foot to armor cables that end in L
    if (def == 'INCL') {

        // get the metric or imperial
        let _u = {}; self.getOptionValueWithSC(pc, s, "U", (g, o) => { _u = o; });

        // get the armor length
        let _a = {}; self.getOptionValueWithSC(pc, s, "A", (g, o) => { _a = o; });

        // add .5 if its meters, otherwise 1 if its feet
        let addon = _u.name == 'M' ? .5 : 1;

        // Adjust the value
        self.setOptionValX(pc, s, '', '', parseFloat(_a.name) + addon, '', 'L');
    }

    // The action to add a foot to armor cables that end in L
    if (def == 'INCL_SENS') {

        // get the metric or imperial
        let _u = {}; self.getOptionValueWithSC(pc, s, "UN", (g, o) => { _u = o; });

        // get the armor length
        let _a = {}; self.getOptionValueWithSC(pc, s, "AL", (g, o) => { _a = o; });

        // add .5 if its meters, otherwise 1 if its feet
        let addon = _u.name == 'M' ? .5 : 1;

        // Adjust the value
        self.setOptionValX(pc, s, '', '', parseFloat(_a.name) + addon, '', 'LN');
    }

    // Remove Connector 1 on a Cable
    if (def == 'CLEAR_C1') {

        self.setOptionValX(pc, s, '', '', '', '', 'C1');
    }
}

export function utilityFunction(def, self, pc, s, opt)
{
    if (def == 'SENS_SET_CABLE')
    {
        self.getGroupID(pc, s, 'Cable', x => {
            if (opt.bl) {
                let v = opt.bl.filter(b => b.config == pc + '_' + x.id)[0]
                if (v) {
                    let _v = v.val;
                    self.setOptionValX(pc, s, '', 'Cable', '', _v);
                }
            } else {
                self.setOptionValX(pc, s, '', 'Cable', '', '');
            }
        });
    }
    if (def == 'CHK_CON2_VALID') {
        let x = 0;
        let y = 1;
    }
}

export function calcSC(calcformula, self, x, dat, state) {
    // first get the default value
    let x_val = '';
    let _partnum = dat.partnum;
    let pnarr = _partnum.split('/')[0].split('-');

    // val represents the part number minus any known mounting options.
    let val = removeMoutingPrefix(_partnum);

    if (!x.calcformlua) {        
        let _defaultval = x.defaultval || '';
        
        // if the shortcode is filled in, find the value of that field
        // if calcsc is filled in grab the value of that short code
        if (x.calcsc) {
            let _c1 = {};
            self.getOptionValueWithSC(x.pcprofile, state, x.calcsc, (g, o) => { _c1 = o; });
            _partnum = _c1.name;
        }

        // if calcstart and len are filled in substrng the PN
        if (x.calcstart && x.calclen) {
            x_val = _partnum.substr(x.calcstart, x.calclen);

            // else use the PN
        } else {
            x_val = _defaultval;
        }
    }
    else if (x.calcformlua == 'LPC1_CALC') {
        pnarr = val.split('/')[0].split('-');

        // C1 is the last segment
        x_val = pnarr[pnarr.length - 1];

    }
    else if (x.calcformlua == 'LPX_CALC') {
        pnarr = val.split('/')[0].split('-');

        // LPX is the first segment
        x_val = pnarr[0];
    }

    return x_val;
}

export function removeMoutingPrefix(partnum)
{
    // val represents the part number minus any known mounting options.
    let val = partnum.toUpperCase();
    let _val = val.startsWith('M/') ? val.substring(2) : val;
    _val = _val.startsWith('M8/') ? _val.substring(3) : _val;
    _val = _val.startsWith('P25/') ? _val.substring(4) : _val;

    return _val;
}

export function isBNC(pn)
{
    let normFX = [
        'F', 'E',
        'F2C', 'E2C',
        'F3C', 'E3C',
        'F4C', 'E4C',
        'E2DA', 'E2DB ', 'F2DA', 'F2DB',
        'F3D', 'E3D',
        'F4D', 'E4D'
    ];

    let moldFX = [
        'FX', 'EX',
        'E2X', 'F2X',
        'F3X', 'E3X',
        'E4X', 'F4X',
        'E2XA', 'E2XB', 'F2XA', 'F2XB'];

    let arr = [
        'F', 'E',
        'E2C', 'F2C',
        'F3C', 'E3C',
        'E4C', 'F4C',
        'E4D', 'F4D',
        'FX', 'EX',
        'E2X', 'F2X',
        'F3X', 'E3X',
        'E4X', 'F4X',
        'EMPP'];

    return normFX.includes(pn) || moldFX.includes(pn) || arr.includes(pn);
}

export function setScript(def, self, pc, s, ssi) {
    let rtn = false;

    let normFX = [
        'F', 'E',
        'F2C', 'E2C',
        'F3C', 'E3C',
        'F4C', 'E4C',
        'E2DA', 'E2DB ','F2DA', 'F2DB',
        'F3D', 'E3D',
        'F4D', 'E4D'
    ];

    let moldFX = [
        'FX', 'EX',
        'E2X', 'F2X',
        'F3X', 'E3X',
        'E4X', 'F4X',
        'E2XA', 'E2XB', 'F2XA', 'F2XB'];

    if (def == 'CHK_CON2_VALID') {

        let _cab = {}; self.getOptionValue(pc, s, "Cable", (g, o) => { _cab = o; });
        let cab = _cab.name;

        let _c1 = {}; self.getOptionValueWithSC(pc, s, "C1", (g, o) => { _c1 = o; });
        let c1 = _c1.name;

        let _c2 = {}; self.getOptionValueWithSC(pc, s, "C2", (g, o) => { _c2 = o; });
        let c2 = _c2.name;

        let _a = {}; self.getOptionValueWithSC(pc, s, "A", (g, o) => { _a = o; });
        let a = _a.name;

        let _l = {}; self.getOptionValueWithSC(pc, s, "L", (g, o) => { _l = o; });
        let l = _l.name;

        // get the metric or imperial
        let _u = {}; self.getOptionValueWithSC(pc, s, "U", (g, o) => { _u = o; });

        let isarmorcable = s.data.filter(e => e.id == pc)[0].parttemp.includes('{Armor Length}');

        let arr = [
            'F', 'E',
            'E2C', 'F2C',
            'F3C', 'E3C',
            'E4C', 'F4C',
            'E4D', 'F4D',
            'FX', 'EX',
            'E2X', 'F2X',
            'F3X', 'E3X',
            'E4X', 'F4X',
            'EMPP'];

        let _pc = s.data.filter(x => x.id == pc)[0];

        if (c2.startsWith("C") && !c1.startsWith("C"))
        {
            _pc.invalidMsg = "Data Collector cables must be built with the data collector connector as the first connector.";
            _pc.invalidActionTxt = "Switch Connector Ends";
            _pc.invalidAction = "FLIPIT";
        }

        if (c1 == "Z" && c2 != "Z" && c2 != "L") {
            _pc.invalidMsg = "Z must be ordered as the second connector.";
            _pc.invalidActionTxt = "Switch Connector Ends";
            _pc.invalidAction = "FLIPIT";
        }

        if (c1 == "L" && c2 != "L") {
            _pc.invalidMsg = "L must be ordered as the second connector.";
            _pc.invalidActionTxt = "Switch Connector Ends";
            _pc.invalidAction = "FLIPIT";
        }

        // If the first connector is a BNC, make them switch it to the second connector
        // unless the second connector is a BNC, L or Z
        if (!_pc.invalidMsg) {
            if (arr.includes(c1) && (!arr.includes(c2) && c2 != "Z" && c2 != "L")) {
                _pc.invalidMsg = "BNC cables must be built with the BNC as the second connector.";
                _pc.invalidActionTxt = "Switch Connector Ends";
                _pc.invalidAction = "FLIPIT";
            }
        }

        if (!_pc.invalidMsg && s.data.filter(x => x.id == pc)[0].parttemp.includes('Armor')) {

            // add .5 if its meters, otherwise 1 if its feet
            let addon = _u.name == 'M' ? .5 : 1;

            if (c2 == 'L' || c2 == 'Z') {
                if (parseFloat(a) > (parseFloat(l) - addon)) {
                    _pc.invalidMsg = "Armor Length must be " + (_u.name == 'M' ? ".5 meters" : "1 foot") +
                        " less for integral cables ending in L or Z.";
                    _pc.invalidActionTxt = "Increase Base Cable Length";
                    _pc.invalidAction = "INCL";
                }
            }
        }

        let approvedNonMoldedCable = cab == 'CB206';
        if (!approvedNonMoldedCable) {
            if (a != l && isarmorcable) {
            // when its an armor cable, with different lengths
            // if the second connector is a BNC, L or Z, make sure the first connector is molded
            let normFX2 = [...normFX, 'L', 'Z'];
                if (normFX.includes(c1) && normFX2.includes(c2)) {
                _pc.invalidMsg =
                    `When a BNC is selected as the first connector on armored cabling, 
                    it must be the epoxied version rather than the molded version.`;
                _pc.invalidActionTxt = "Change Conenctor 1";
                _pc.invalidAction = "CLEAR_C1";
            }
        }
        }

    }

    if (def == 'CHK_CON_SENSOR') {
        let _c2 = {}; self.getOptionValueWithSC(pc, s, "C2", (g, o) => { _c2 = o; });
        let c2 = _c2.name;

        let _a = {}; self.getOptionValueWithSC(pc, s, "AL", (g, o) => { _a = o; });
        let a = _a.name;

        let _l = {}; self.getOptionValueWithSC(pc, s, "LN", (g, o) => { _l = o; });
        let l = _l.name;

        let _u = {}; self.getOptionValueWithSC(pc, s, "UN", (g, o) => { _u = o; });

        let _pc = s.data.filter(x => x.id == pc)[0];

        if (!_pc.invalidMsg && s.data.filter(x => x.id == pc)[0].parttemp.includes('Armor')) {

            // add .5 if its meters, otherwise 1 if its feet
            let addon = _u.name == 'M' ? .5 : 1;

            if (c2 == 'L' || c2 == 'Z') {
                if (parseFloat(a) > (parseFloat(l) - addon)) {
                    _pc.invalidMsg = "Armor Length must be " + (_u.name == 'M' ? ".5 meters" : "1 foot") +
                        " less for integral cables ending in L or Z.";
                    _pc.invalidActionTxt = "Increase Base Cable Length";
                    _pc.invalidAction = "INCL_SENS";
                }
            }
        }
    }

    if (def == "LEN_PAD_ZEROS") {
        // Pad this chunk of the partnumber with 3 '0's 
        // ignoring the decimal
        let ar_option_name = ssi.option_name.split('.');
        let i = 0;
        for (i = 0; i < ar_option_name.length; i++) {
            if (i == 0) {
                ssi.option_name = ar_option_name[i].padStart(3, '0');
            } else {
                ssi.option_name += '.' + ar_option_name[i];
            }
        }

        //is the cable armored

        // check for armor cable and whether the length of armor and cable are different
        let cab = 0; let _cab = {}; self.getOptionValue(pc, s, "Cable", (g, o) => { _cab = o; });
        let arm = 0; let _arm = {}; self.getOptionValue(pc, s, "Armor Length", (g, o) => { _arm = o; });
        let len = 0; let _len = {}; self.getOptionValue(pc, s, "Length", (g, o) => { _len = o; });
        let isarmorcable = s.data.filter(e => e.id == pc)[0].parttemp.includes('{Armor Length}');
		
		// Get the connector 1 value
        let _c1 = {}; self.getOptionValueWithSC(pc, s, "C1", (g, o) => { _c1 = o; });
        let c1 = _c1.name;
		
		// Get the connector 2 value
        let _c2 = {}; self.getOptionValueWithSC(pc, s, "C2", (g, o) => { _c2 = o; });
        let c2 = _c2.name;

		// get the numeric value of the armor and cable lengths
        arm = parseFloat(_arm.name);
        len = parseFloat(_len.name);
        cab = _cab.name;

        let approvedNonMoldedCable = cab == 'CB206';
        //if (!specialCondition)
        {

            if ((arm < len || !isarmorcable || approvedNonMoldedCable)) {// && cab!="CB206" ) {
            // FX and EX are not allowed when the lengths are different, or if it isnt armor at all
            // Setting open close to -100 effectively removes it from being a valid option

                // Special Condition, they are allowed if the second connector is
            // a BNC, L or Z
            normFX.push('L'); normFX.push('Z');
                if (!isarmorcable || !normFX.includes(c2) || approvedNonMoldedCable)
                self.configlist.filter(x => moldFX.includes(x.name)).forEach(x => x.openclose = '-100');

            } else {
            // All else if its armor cable with same length remove the normal connectors
            self.configlist.filter(x => normFX.includes(x.name)).forEach(x => x.openclose = '-100');

        }
        }
        //ssi.option_title = self.trim(ssi.option_name, '0');
        rtn = true;
    }
    else if (def == "FLX_RESTRICTIONS") {

        // First get the option values values of each group
        let co = 0; let _c = {}; self.getOptionValue(pc, s, "Conduits", (g, o) => { _c = o; });
        let gr = 0; let _g = {}; self.getOptionValue(pc, s, "Grey Cordgrips", (g, o) => { _g = o; });
        let bl = 0; let _b = {}; self.getOptionValue(pc, s, "Black Cordgrips", (g, o) => { _b = o; });
        let st = 0; let _s = {}; self.getOptionValue(pc, s, "Stainless Cordgrips", (g, o) => { _s = o; });

        // conduit takes the space of 6 cordgrips
        co = parseInt(_c.name) * 6;

        // the cordgrip values are represented in hex (I.E. 12 = C)
        gr = parseInt(_g.name, 16);
        bl = parseInt(_b.name, 16);
        st = parseInt(_s.name, 16);

        // set sine defaults for values if they were missing
        if(!co) co = 0;
        if (!gr) gr = 0;
        if (!bl) bl = 0;
        if (!st) st = 0;

        // calculate the remaining space to put cordgrips or conduits
        let rem = 12 - co - gr - bl - st; 

        // if the conduit is not selected
        if (!_c.configgroup || !s.selections[pc + "_" + _c.configgroup]) {
            // loop the options
            self.configlist.filter(x => {
                //filter Conduit Options that are greater then the remaining space
                return x.grouptitle.includes("Conduit") && parseInt(x.name) * 6 > rem;
                // disable any results
            }).forEach(x => x.openclose = '-100');
        }

        // the rest of these follow the same pattern as the conduit
        if (!_g.configgroup || !s.selections[pc + "_" + _g.configgroup]) {
            self.configlist.filter(x => {
                return x.grouptitle.includes("Grey Cordgrip") && parseInt(x.name, 16) > rem;
            }).forEach(x => x.openclose = '-100');
        }
        if (!_b.configgroup || !s.selections[pc + "_" + _b.configgroup]) {
            self.configlist.filter(x => {
                return x.grouptitle.includes("Black Cordgrip") && parseInt(x.name, 16) > rem;
            }).forEach(x => x.openclose = '-100');
        }
        if (!_s.configgroup || !s.selections[pc + "_" + _s.configgroup]) {
            self.configlist.filter(x => {
                return x.grouptitle.includes("Stainless Cordgrip") && parseInt(x.name, 16) > rem;
            }).forEach(x => x.openclose = '-100');
        }
    }
    else if (def == "LP_PARTNUM_FIXES") {
        let _c = {}; self.getOptionValue(pc, s, "LP", (g, o) => { _c = o; });

        // Pad this chunk of the partnumber with 3 '0's
        // ignoring the decimal

        if (_c.name.startsWith("LPT")) {
            // All axis have same configurations
            ssi.option_name = ssi.option_name.replace("$$$",
                "{Measurement Range}{Range Type}{Frequency Range}");
            ssi.option_name = ssi.option_name.replace("$$$",
                "{Measurement Range}{Range Type}{Frequency Range}");
            ssi.option_name = ssi.option_name.replace("$$$",
                "{Measurement Range}{Range Type}{Frequency Range}-{Tolerance}");

            // Y and Z Axis have own configurations
            //ssi.option_name = ssi.option_name.replace("$$$",
            //    "{Measurement Range Y Axis}{Range Type Y Axis}{Frequency Range Y Axis}");
            //ssi.option_name = ssi.option_name.replace("$$$",
            //    "{Measurement Range Z Axis}{Range Type Z Axis}{Frequency Range Z Axis}");
        }
        else {
            ssi.option_name = ssi.option_name.replace("$$$", "$").replace("$$", "$");
            ssi.option_name = ssi.option_name.replace("$$$", "$");
            ssi.option_name = ssi.option_name.replace("$",
                "{Measurement Range}{Range Type}{Frequency Range}-{Tolerance}");
        }
        
        rtn = true;
    }
    else if (def == "TMP_PARTNUM_FIXES") {
        // Pad this chunk of the partnumber with 3 '0's 
        // ignoring the decimal

        //if (
        //    ssi.option_name.startsWith("TREA") ||
        //    ssi.option_name.startsWith("TRCA") ||
        //    ssi.option_name.startsWith("TXFA") ||
        //    ssi.option_name.startsWith("TXEA") ||
        //    ssi.option_name.startsWith("TSFA") ||
        //    ssi.option_name.startsWith("BSFA") ||
        //    ssi.option_name.startsWith("TCEB") ||
        //    false
        //) {
        //    ssi.option_name = ssi.option_name.substr(0, 5) + "{TMP Stud Type}" + ssi.option_name.substr(6);
        //    ssi.repeat = true;
        //}

        //if (
        //    ssi.option_name.startsWith("UEA") ||
        //    ssi.option_name.startsWith("UEB") ||
        //    false
        //) {
        //    ssi.option_name = ssi.option_name.substr(0, 4) + "{TMP Stud Type}" + ssi.option_name.substr(5);
        //    ssi.repeat = true;
        //}

        //if (
        //    ssi.option_name.startsWith("MEB") ||
        //    ssi.option_name.startsWith("MCB") ||
        //    ssi.option_name.startsWith("TEB") ||
        //    ssi.option_name.startsWith("TCB") ||
        //    ssi.option_name.startsWith("TEA") ||
        //    ssi.option_name.startsWith("TCA") ||
        //    false
        //) {
        //    ssi.option_name = ssi.option_name.substr(0, 4) + "{TMP Stud Type 2}" + ssi.option_name.substr(5);
        //    ssi.repeat = true;
        //}
        rtn = true;
    }
    else if(def == "CAB_LESS_ARMOR_PRICE")
    {
        // Calculate how much less armor in feet is on the cable
        // multiply this value by 1.5 and subtract this value 
        // from the total cost of the cable
        self.newdata.forEach(x => {
            if (pc == x.id) {
                if (x.parttemp.includes("Armor Length")) {
                    self.getOptionValue(pc, s, "Armor Length",
                        (g, o) => {

                            let obj = ssi;

                            // There are a couple of parts that reduce the price based on less
                            // length of the armor - I think hydrolic are the only ones that do this
                            // so this is hard coded - This could be ported to a new customer field (I.E. Alt Price)
                            let less_price = isNaN(obj.form_price) ? 0 : +obj.form_price;

                            if (!less_price) {
                                less_price = 1.5;
                                if (obj.option_name == "CB502") { less_price = 4.95; }
                                if (obj.option_name == "CB511") { less_price = 4.7; }
                                if (obj.option_name == "CB512") { less_price = 4.5; }

                                if (obj.option_name == "CB202") { less_price = 1.74; }
                                if (obj.option_name == "CB206") { less_price = 2.05; }
                                if (obj.option_name == "CB212") { less_price = 1.80; }
                                if (obj.option_name == "CB218") { less_price = 2.13; }

                                if (obj.option_name == "CB296") { less_price = 2.05; }
                                if (obj.option_name == "CB298") { less_price = 2.13; }

                                if (obj.option_name == "CB602") { less_price = 2.64; }
                                if (obj.option_name == "CB606") { less_price = 0.90; }
                                if (obj.option_name == "CB611") { less_price = 2.67; }
                                if (obj.option_name == "CB612") { less_price = 1.80; }
                                if (obj.option_name == "CB618") { less_price = 2.88; }

                                if (obj.option_name == "CB802") { less_price = 2.04; }
                                if (obj.option_name == "CB806") { less_price = 0.30; }
                                if (obj.option_name == "CB810") { less_price = 2.04; }
                                if (obj.option_name == "CB811") { less_price = 2.34; }
                                if (obj.option_name == "CB812") { less_price = 1.50; }
                                if (obj.option_name == "CB818") { less_price = 2.88; }
                                if (obj.option_name == "CB819") { less_price = 1.50; }
                            }

                            // Important to multiply by mult since we
                            // have a qty field that can have a multipler
                            let _qty = parseFloat(o.name) * ssi.mult;
                            _qty -= ssi.freeqty;
                            if (_qty < 0) _qty = 0;

                            // When calculating the difference
                            // for pricing, use the adjusted qty
                            let dif = ssi.adjustqty - _qty;
                            let less = dif * less_price;
                            ssi.tot_price -= less;

                            // Add to the price info array
                            x.priceinfo.push({
                                property: 'Less Armor',
                                option: 'Discount', qty: dif,
                                price: less_price,
                                tot_price: less,
                                id: '', gid: ''
                            });
                        });
                }
            }
        });
        if (ssi.option_name == 'CB104') { ssi.tot_price = 0; }
        if (ssi.option_name == 'CB108') { ssi.tot_price = 0; }
        if (ssi.option_name == 'CB117') { ssi.tot_price = 0; }


        let isportperm = s.data.filter(e => e.id == pc)[0].parttemp.includes('{Armor Length}');
        let arm = 0; self.getOptionValue(pc, s, "Armor Length", (g, o) => { arm = o; });


        rtn = true;
    }

    return rtn;
}

export function checkRequired(self, pc,s, dat ,y)
{
    //for (const property in s.selections) {

    //    let groups = [];
    //    let group = {};
    //    let option = {};
    //    s.data.forEach(d => {
    //        if (d.id == pc) {
    //            let _g = d.configgroup.find(f => pc + '_' + f.id == property);
    //            group = _g || { name: '', type: '1' };
    //            groups.push(group);
    //        }
    //    });
    //}

    let rtn = true;

    // If there is a length there must be a cable
    if (dat.parttemp.includes("{Length}"))
    {
        let v = y.find(x => x.name == "Cable") || { val: '' };
        if (!v.val) { rtn = false; }
    }

    return rtn;
}

let PseudoSession = {};

export function sessGetObj(key) {
    //return JSON.parse(window.sessionStorage.getItem(key));
    if (PseudoSession[key]) return JSON.parse(PseudoSession[key]);
    return null;
}

export function sessSetObj(key, val)
{
    try {
        //window.sessionStorage.setItem(key, JSON.stringify(val));
        PseudoSession[key] = JSON.stringify(val);
    }
    catch (e) {

    }
}